import type { RentalApplication } from '../graphql/queries';

export function getStreetFromApplication(application: RentalApplication): string {
  const street =
    application.rentalListing?.address?.street ?? application.applicationShareInformation?.propertyAddress?.street;
  const unit =
    application.rentalListing?.address?.unit || application.applicationShareInformation?.propertyAddress?.unit;
  return `${street ?? ''}${unit ? ` ${unit}` : ''}`;
}
